import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input', 'counter', 'wrapper', 'helper'];

  connect() {
    if (this.hasInputTarget) this.updateCount();
    if (this.hasInputTarget && this.inputTarget.dataset.hasError === 'true') {
      this.showError();
    }
  }

  showError() {
    if (this.hasWrapperTarget) this.wrapperTarget.classList.add('has-error');

    if (this.hasInputTarget) {
      this.inputTarget.classList.add(
        'border-red-300',
        'text-red-1000',
        'placeholder-red-1000'
      );
    }

    if (this.hasHelperTarget) this.helperTarget.classList.add('text-red-1000');
  }

  updateCount() {
    if (!this.hasInputTarget || !this.hasCounterTarget) return;
    const count = (this.inputTarget.value || '').length;

    const maxAttr = this.inputTarget.maxLength;
    const dataMax = Number(this.inputTarget.dataset.maxLength || 0);
    const max = (() => {
      if (maxAttr > 0) {
        return maxAttr;
      } else if (dataMax > 0) {
        return dataMax;
      } else {
        return 250;
      }
    })();

    this.counterTarget.textContent = `${count} / ${max}`;
  }
}
